<template>
  <div class="login">
    <div class="login-hd">
      <ul>
        <li @click="changeTab('organ')" :class="{active: type === 'organ' }">机构登录</li>
        <li @click="changeTab('personal')" :class="{active: type !== 'organ' }">个人登录</li>
      </ul>
    </div>
    <div class="login-bd">
      <!-- 机构登录 -->
      <el-form :model="organ" ref="organForm" v-show="type === 'organ'">
        <!-- 第一步 -->
        <div class="login-organ" v-show="!isOrgan">
          <el-form-item>
            <el-input type="email" v-model="organ.mail" placeholder="邮箱"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              type="password"
              v-model="organ.password"
              placeholder="密码"
              @keyup.enter.native="onGetManager"
            ></el-input>
          </el-form-item>
          <div class="login-bar">
            <div class="is-left">
              <el-checkbox v-model="remember">记住我</el-checkbox>
            </div>
            <div class="is-right">
              <p>
                <router-link :to="{path: '/member/reset_password', query: {type: 'organ'}}">忘记密码?</router-link>
              </p>
            </div>
          </div>
          <el-form-item>
            <el-button class="btn-block" type="primary" @click="onGetManager">登录</el-button>
          </el-form-item>
          <div class="login-bar">
            <div class="is-right">
              <router-link
                :to="{path: '/member/register', query: {type: 'organ'}}"
                style="color:#1b5ffe;"
              >新用户注册</router-link>
            </div>
          </div>
        </div>
        <!-- 第二步 -->
        <div class="login-organ" v-show="!!isOrgan">
          <el-form-item>
            <el-select v-model="organ.managerPhone" style="width:100%;">
              <el-option
                v-for="(item, index) in managerPhoneList"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="imageVerifyCode" placeholder="图形验证码" class="image-code-input"></el-input>
            <img
              :src="imageCodeUrl"
              class="image-code"
              alt="点击切换验证码"
              title="点击切换验证码"
              @click="changeImageCode"
            >
          </el-form-item>
          <el-form-item>
            <el-input
              type="number"
              v-model="organ.managerPhoneVerifyCode"
              placeholder="验证码"
              class="phone-code-input"
              @keyup.enter.native="onLoginOrga"
            ></el-input>
            <timer-button @click.native="onSendOrgaPhoneCode" ref="orgaPhoneCode"></timer-button>
            <!-- <el-button type="primary" class="phone-code-btn" @click="onSendOrgaPhoneCode">发送验证码</el-button> -->
          </el-form-item>
          <el-form-item>
            <el-button class="btn-block" type="primary" @click="onLoginOrga">登录</el-button>
          </el-form-item>
          <div class="login-bar">
            <div class="is-left">
              <span style="color:#1b5ffe;cursor:pointer;" @click="isOrgan = !isOrgan">&lt; 返回上一步</span>
            </div>
          </div>
        </div>
      </el-form>
      <!-- 个人登录 -->
      <el-form :model="personal" ref="personalForm" v-show="type !== 'organ'">
        <el-form-item>
          <el-select v-model="phoneCode" class="phone-areacode">
            <el-option
              v-for="(item, index) in phoneCodeList"
              :key="index"
              :label="`+${item.code}`"
              :value="`+${item.code}`"
            >
              <span style="float: left">{{ item.name }}</span>
              <span
                style="float: right; padding-left: 20px; color: #8492a6; font-size: 13px"
              >+{{ item.code }}</span>
            </el-option>
          </el-select>
          <el-input type="number" v-model="personal.phone" placeholder="手机号" class="phone-input"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            type="password"
            v-model="personal.password"
            placeholder="密码"
            autocomplete="off"
            @keyup.enter.native="onLoginPersonal"
          ></el-input>
        </el-form-item>
        <div class="login-bar">
          <div class="is-left">
            <el-checkbox v-model="remember">记住我</el-checkbox>
          </div>
          <div class="is-right">
            <p>
              <router-link :to="{path: '/member/reset_password', query: {type: 'personal'}}">忘记密码?</router-link>
            </p>
          </div>
        </div>
        <el-form-item>
          <el-button class="btn-block" type="primary" @click="onLoginPersonal">登录</el-button>
        </el-form-item>
        <div class="login-bar">
          <div class="is-left">第三方登录：
            <div class="sns">
              <a href="javascript:;" title="微信" class="sns-wechat" @click="SNSToLogin('wechat')"></a>
              <a href="javascript:;" title="新浪" class="sns-sina" @click="SNSToLogin('sina')"></a>
              <a href="javascript:;" title="QQ" class="sns-qq" @click="SNSToLogin('qq')"></a>
            </div>
          </div>
          <div class="is-right">
            <router-link
              :to="{path: '/member/register', query: {type: 'personal'}}"
              style="color:#1b5ffe;"
            >新用户注册</router-link>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import hash from 'hash.js'
import Cookies from 'js-cookie'
import {
  getPhoneCode,
  getImageCode,
  sendCode,
  phoneLogin,
  mailLogin,
  getManager,
  thirdLogin,
  getShareAppToken
} from '@/api/zaiart'

import TimerButton from '../common/timerButton'

let snsConfig = {
  wechat: {
    url: 'https://open.weixin.qq.com/connect/qrconnect',
    appid: 'wxd54d990607580ebf',
    redirect_uri: `https://img.zai-art.com/auth.html?redirect_uri=${encodeURIComponent(
      process.env.VUE_APP_LOCATION_URL
    )}`,
    response_type: 'code',
    scope: 'snsapi_login',
    state: '4'
  },
  sina: {
    url: 'https://api.weibo.com/oauth2/authorize',
    client_id: '1086831308',
    redirect_uri: `https://img.zai-art.com/auth.html?redirect_uri=${encodeURIComponent(
      process.env.VUE_APP_LOCATION_URL
    )}`,
    response_type: 'code',
    scope: 'all',
    state: '5'
  },
  qq: {
    url: 'https://graph.qq.com/oauth2.0/authorize',
    client_id: '101343480',
    redirect_uri: `https://img.zai-art.com/auth.html?redirect_uri=${encodeURIComponent(
      process.env.VUE_APP_LOCATION_URL
    )}`,
    response_type: 'code',
    scope: 'get_user_info',
    state: '3'
  }
}
export default {
  name: 'Login',
  components: { TimerButton },
  data: () => ({
    type: 'organ',
    managerPhoneList: [],
    phoneCodeList: [],
    phoneCode: '+86',
    sessionId: '',
    imageCodeUrl: '',
    imageVerifyCode: '',
    personal: { phone: '', password: '' },
    organ: {
      mail: '',
      password: '',
      managerPhone: '',
      managerPhoneVerifyCode: ''
    },
    isOrgan: false,
    remember: false
  }),
  watch: {
    $route: function(route) {
      this.type = route.query.type
    }
  },
  methods: {
    // 初始化
    init() {
      this.getPhoneCode()
      this.changeImageCode()
    },
    // tab切换
    changeTab(type) {
      // let path = this.$route.path
      // this.$router.push({ path: path, query: { type: type } })
      this.type = type
    },
    // 获取手机区号
    getPhoneCode() {
      return getPhoneCode().then(response => {
        this.phoneCodeList = response.data.countries
      })
    },
    // 切换验证码
    changeImageCode() {
      this.sessionId = Math.random()
        .toString(36)
        .substr(2)
      this.imageCodeUrl = getImageCode(this.sessionId)
    },
    // 发送机构注册管理员手机验证码
    onSendOrgaPhoneCode() {
      let param = {
        sessionId: this.sessionId,
        imageVerifyCode: this.imageVerifyCode,
        account: this.organ.managerPhone,
        sendFuncType: 'VERIFY_MANAGER'
      }
      if (!this.organ.managerPhone) {
        this.$message.error('请选择管理员手机号')
        return false
      } else if (!param.imageVerifyCode) {
        this.$message.error('请输入图形验证码')
        return false
      }
      // 验证码倒计时开始
      this.$refs.orgaPhoneCode.start()
      this.sendCode(param).catch(() => {
        this.$refs.orgaPhoneCode.stop()
      })
    },
    // 发送验证码
    sendCode(param) {
      return sendCode(param).then(response => {
        this.$message({
          type: 'success',
          message: '验证码已发送，请查收'
        })
      })
    },
    // 第三方去登录
    SNSToLogin(type) {
      let snsData = snsConfig[type]
      let paramArr = []
      for (var item in snsData) {
        if (item === 'url') {
          continue
        }
        if (item === 'redirect_uri') {
          paramArr.push(item + '=' + encodeURIComponent(snsData[item]))
        } else {
          paramArr.push(item + '=' + snsData[item])
        }
      }
      let snsUrl = snsData.url + '?' + paramArr.join('&')
      window.location.href = snsUrl
    },
    // 获取管理员列表（机构登录第一步）
    onGetManager() {
      // 表单验证
      if (!this.organ.mail) {
        this.$message.error('请输入邮箱')
        return false
      } else if (!/@/gi.test(this.organ.mail)) {
        this.$message.error('请输入正确的邮箱地址')
        return false
      } else if (!this.organ.password) {
        this.$message.error('请输入密码')
        return false
      }
      let param = { mail: this.organ.mail, password: this.organ.password }
      param.password = this.setPassword(param.password)
      return getManager(param).then(response => {
        this.isOrgan = true
        this.managerPhoneList = response.data.list || []
        this.organ.managerPhone = this.managerPhoneList[0]
      })
    },
    // 机构登录
    onLoginOrga() {
      // 表单验证
      if (!this.organ.managerPhone) {
        this.$message.error('请选择管理员手机号')
        return false
      } else if (!this.organ.managerPhoneVerifyCode) {
        this.$message.error('请输入管理员手机验证码')
        return false
      }
      let param = JSON.parse(JSON.stringify(this.organ))
      param.password = this.setPassword(param.password)
      param.utmSource = location.href
      return mailLogin(param).then(response => {
        // 登录成功
        this.isOrgan = false
        this.loginSuccess(response.data, param)
      })
    },
    // 个人登录
    onLoginPersonal() {
      // 表单验证
      if (!this.personal.phone) {
        this.$message.error('请输入手机号')
        return false
      } else if (!this.personal.password) {
        this.$message.error('请输入密码')
        return false
      }
      let param = JSON.parse(JSON.stringify(this.personal))
      param.phone = `${this.phoneCode} ${param.phone}`
      param.password = this.setPassword(param.password)
      param.utmSource = location.href
      return phoneLogin(param).then(response => {
        // 登录成功
        this.loginSuccess(response.data, param)
      })
    },
    // 第三方登录
    onSNSLogin(param) {
      thirdLogin(param).then(response => {
        let code = response.code
        if (code === 1) {
          // 登录成功
          this.loginSuccess(response.data, param)
        } else if (code === 30402) {
          // 未注册
          this.$router.push({
            path: '/member/bind_phone',
            query: { code: param.code, type: param.loginType }
          })
        }
      })
    },
    // 登录成功
    loginSuccess(data) {
      // 数据存储
      // localStorage.setItem('isRemember', this.remember)
      // localStorage.setItem('uid', data.uid)
      localStorage.setItem('token', data.token)
      localStorage.setItem('userInfo', JSON.stringify(data.userInfo))
      // 设置shareApp Token
      this.setShareAppToken()
      // 跳转
      this.$router.push({ path: '/', query: { uid: data.uid } })
    },
    // 密码加密
    setPassword(pwd) {
      return hash
        .sha256()
        .update(
          `ad5e38a3999d923fd852f834c4e4549652f61def3e48f6118cdab3a812615519${pwd}`
        )
        .digest('hex')
    },
    setShareAppToken() {
      getShareAppToken().then(response => {
        Cookies.set('token', response.data.token, {
          domain: process.env.VUE_APP_COOKIES_DOMAIN,
          expires: 365
        })
      })
    }
  },
  created() {
    let query = this.$route.query
    if (query.type) {
      this.type = query.type
    }
    // 第三方登录
    if (query.code && query.state) {
      this.onSNSLogin({
        code: query.code,
        loginType: query.state,
        utmSource: location.href
      })
    }
    // 初始化
    this.init()
  }
}
</script>
<style>
.login {
  width: 278px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
}
.login .login-hd {
  height: 46px;
  background-color: #f0f5fb;
}
.login .login-hd li {
  float: left;
  width: 50%;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  line-height: 46px;
  color: #666;
}
.login .login-hd li.active {
  color: #333;
}
.login .login-bd {
  padding: 12px 16px;
}
.login .el-form-item {
  margin-bottom: 6px;
}
.login .el-form-item__content {
  line-height: 0;
}
.login .el-input__inner {
  height: 34px;
  display: block;
}
.login .phone-areacode {
  float: left;
  width: 74px;
}
.login .phone-input {
  float: right;
  width: 166px;
}
.login .image-code-input {
  float: left;
  width: 154px;
}
.login .image-code {
  cursor: pointer;
  float: right;
  width: 80px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  background-color: #efefef;
}
.login .phone-code-input {
  float: left;
  width: 154px;
  line-height: 34px;
}
.login .phone-code-btn {
  float: right;
  width: 80px;
  padding: 9px 0;
}
.login .btn-block {
  width: 100%;
  padding: 9px 0;
}
.login .el-button--primary {
  background-color: #1e88f5;
  box-shadow: 0 0 10px rgba(30, 136, 245, 0.4);
}
.login .login-bar {
  padding-top: 4px;
  margin-bottom: 8px;
  font-size: 12px;
  list-style: 20px;
  color: #999;
  overflow: hidden;
}
.login .login-bar .el-checkbox__label {
  font-size: 12px;
  color: #999;
}
.login .sns {
  display: inline-block;
}
.login .sns a {
  margin-right: 4px;
  display: inline-block;
  background-size: contain;
}
.login .sns a:hover {
  background-size: contain;
}
.login .sns-wechat {
  width: 12px;
  height: 10px;
  background: url('../../../assets/img/icon/sns_wechat.png') no-repeat;
}
.login .sns-wechat:hover {
  background: url('../../../assets/img/icon/sns_wechat_hover.png') no-repeat;
}
.login .sns-qq {
  width: 9px;
  height: 10px;
  background: url('../../../assets/img/icon/sns_qq.png') no-repeat;
}
.login .sns-qq:hover {
  background: url('../../../assets/img/icon/sns_qq_hover.png') no-repeat;
}
.login .sns-sina {
  width: 12px;
  height: 10px;
  background: url('../../../assets/img/icon/sns_sina.png') no-repeat;
}
.login .sns-sina:hover {
  background: url('../../../assets/img/icon/sns_sina_hover.png') no-repeat;
}
</style>
